import moment from 'moment'

export const customerDocumentsAbtractState = {
  name: 'customers.customer.documents',
  abstract: true,
  url: '/documents',
}

export const customerDocumentsState = {
  name: 'customers.customer.documents.year',
  url: '/:year',
  resolve: {
    documents: (customer, $stateParams) => {
      'ngInject'
      const from = moment().year($stateParams.year).startOf('year').format('YYYY-MM-DD')
      const to = moment().year($stateParams.year).endOf('year').format('YYYY-MM-DD')
      return customer.getDocuments(from, to)
    },
  },
  views: {
    'content@customers': 'customerDocumentsComponent',
  },
}

export const customerDocumentsRunblock = ($transitions, $state) => {
  'ngInject'
  $transitions.onBefore({ to: (state) => state.name === customerDocumentsAbtractState.name }, () => {
    return $state.target(customerDocumentsState.name, { year: new Date().getFullYear() })
  })
}



// WEBPACK FOOTER //
// ./app/documents/documents.states.js